<template>
  <div>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-toolbar-title style="padding: 8px 0px;">
            <div class="text-left">
              <h3>Clients</h3>
            </div>
          </v-toolbar-title>
          <v-btn dark absolute bottom small right fab @click="createClient">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-toolbar dense>
          <v-toolbar-title style="padding: 8px 0px;">
            <div class="text-left">
              <v-badge
                v-for="(filter, i) in clientsFilter"
                :key="i"
                bordered
                :color="filter.bg_color"
                :content="clientCount(filter.type).toString()"
                overlap
                style="margin-right:20px"
              >
                <v-btn
                  :color="filter.open ? filter.bg_color : 'transparent'"
                  :class="filter.open ? 'white--tex' : 'black--text'"
                  @click="filterArrayClients(filter)"
                  depressed
                >{{ filter.filterName }}</v-btn>
              </v-badge>
            </div>
          </v-toolbar-title>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row class="fill-height" align="center" justify="start">
      <template v-for="(item, i) in getClients">
        <v-col :key="i" cols="12" lg="3" md="4" sm="6" xs="12">
          <v-card @click="gotoClient(item.id)" class="card-animated text-center" v-ripple>
            <v-card-title>
              {{ item.name }}
              <v-spacer />
              <div>
                <v-chip
                  class="ma-2"
                  :color="item.state | filterColor(clientStatusTemplate, 'bg')"
                  :text-color="
                    item.state | filterColor(clientStatusTemplate, 'txt')
                  "
                >{{ item.state }}</v-chip>
              </div>
            </v-card-title>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </div>
</template>

<script>
import gsap from "gsap";
import { mapGetters, mapMutations, mapActions } from "vuex";
import router from "@/router";
export default {
  name: "ClientList",
  data: () => ({
    clientStatusTemplate: [
      {
        type: "client",
        bg_color: "#2ecc71",
        text_color: "#fff"
      },
      {
        type: "lead",
        bg_color: "#f1c40f",
        text_color: "#fff"
      },
      {
        type: "lost",
        bg_color: "#e74c3c",
        text_color: "#fff"
      }
    ],
    clientsFilter: [
      {
        filterName: "Client",
        bg_color: "#2ecc71",
        open: true,
        type: "client"
      },
      {
        filterName: "Lead",
        bg_color: "#f1c40f",
        open: true,
        type: "lead"
      },
      {
        filterName: "Lost",
        open: true,
        type: "lost",
        bg_color: "#e74c3c"
      }
    ],
    clients: []
  }),
  created() {},
  updated() {
    gsap.from(".card-animated", {
      duration: 0.2,
      opacity: 0,
      scale: 0,
      y: 100,
      ease: "power1",
      stagger: {
        each: 0.05,
        from: "left"
      }
    });
  },
  mounted() {
    gsap.from(".card-animated", {
      duration: 0.2,
      opacity: 0,
      scale: 0,
      y: 100,
      ease: "power1",
      stagger: {
        each: 0.05,
        from: "left"
      }
    });
  },
  filters: {
    filterColor(type, array, attr) {
      if (attr == "bg") {
        return array.find(t => t.type == type).bg_color;
      } else if (attr == "txt") {
        return array.find(t => t.type == type).text_color;
      }
    }
  },
  computed: {
    ...mapGetters(["getClientById", "getClients"])
  },
  methods: {
    ...mapMutations(["SET_CURRENT_CLIENT"]),
    ...mapActions(["loadCurrentClient", "createNewClient"]),

    gotoClient(id) {
      this.loadCurrentClient(id);
      router.push({ name: "clientprofile", params: { id } });
    },
    filterArrayClients(filter) {
      console.log(filter);
      console.log(this.clientsFilter);
      console.log(this.getClients);

      this.getClients.filter(c => {});

      filter.open = !filter.open;
      let tempClientsArray = [];
      this.getClients.find(c => {
        this.clientsFilter.map(f => {
          if (f.open == true) {
            if (c.state == f.type) {
              tempClientsArray.push(c);
            }
          }
        });
      });
      this.clients = tempClientsArray;
    },
    createClient() {
      let tempClient = null;
      this.createNewClient().then(data => {
        data.get().then(docSnap => {
          tempClient = {
            id: docSnap.id,
            ...docSnap.data(),
            agents: [],
            notes: []
          };
          this.SET_CURRENT_CLIENT(tempClient);
          this.$router.push({
            name: "clientprofile",
            params: { id: docSnap.id }
          });
        });
      });
    },
    clientCount(t) {
      return this.getClients.filter(c => c.state == t).length;
    }
  }
};
</script>
